(() => {
  const STORAGE_KEY = 'dalji:wishlist:v1';
  const MAX_ITEMS = 40;
  const STOCK_LIMIT_MESSAGE = 'Só há 1 unidade deste item em estoque.';

  const normalizeCartError = (message) => {
    const value = String(message || '');
    return /quantidade m[aá]xima|estoque|stock|disponib|add more|adicionar mais/i.test(value)
      ? STOCK_LIMIT_MESSAGE
      : value;
  };

  const read = () => {
    try {
      const value = JSON.parse(window.localStorage.getItem(STORAGE_KEY) || '[]');
      return Array.isArray(value) ? [...new Set(value.map(String))].slice(0, MAX_ITEMS) : [];
    } catch (error) {
      return [];
    }
  };

  const write = (items) => {
    const next = [...new Set(items.map(String))].slice(0, MAX_ITEMS);
    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(next));
    } catch (error) {
      return false;
    }
    return next;
  };

  const contains = (id) => read().includes(String(id));

  const updateButton = (button, items = read()) => {
    const active = items.includes(String(button.dataset.productId));
    const title = button.dataset.productTitle || 'este produto';
    const label = active ? 'Remover dos favoritos' : 'Adicionar aos favoritos';
    button.setAttribute('aria-pressed', String(active));
    button.setAttribute('aria-label', `${label}: ${title}`);
    button.setAttribute('title', label);
    const visibleLabel = button.querySelector('[data-wishlist-label]');
    if (visibleLabel) visibleLabel.textContent = label;
  };

  const updateInterface = () => {
    const items = read();
    document.querySelectorAll('[data-wishlist-button]').forEach((button) => updateButton(button, items));
    document.querySelectorAll('[data-wishlist-count]').forEach((counter) => {
      counter.textContent = items.length > 99 ? '99+' : String(items.length);
      counter.hidden = items.length === 0;
    });
    return items;
  };

  let toastTimer;
  const notify = (message) => {
    let toast = document.querySelector('[data-wishlist-toast]');
    if (!toast) {
      toast = document.createElement('div');
      toast.className = 'wishlist-toast';
      toast.dataset.wishlistToast = '';
      toast.setAttribute('role', 'status');
      toast.setAttribute('aria-live', 'polite');
      document.body.appendChild(toast);
    }
    toast.textContent = message;
    toast.classList.add('is-visible');
    window.clearTimeout(toastTimer);
    toastTimer = window.setTimeout(() => toast.classList.remove('is-visible'), 2200);
  };

  const CART_ERROR_KEY = 'dalji:wishlist-cart-error';
  let cartErrorTimer;

  const readCartDrawerError = () => {
    try {
      return window.sessionStorage.getItem(CART_ERROR_KEY) || '';
    } catch (error) {
      return '';
    }
  };

  const scrollCartDrawerToError = (element) => {
    const scrollContainer = element.closest('.cart-drawer__body');
    if (!scrollContainer) return;

    window.requestAnimationFrame(() => {
      scrollContainer.scrollTop = 0;
    });
  };

  const renderCartDrawerError = () => {
    const message = readCartDrawerError();
    document.querySelectorAll('[data-wishlist-cart-error]').forEach((element) => {
      const messageElement = element.querySelector('[data-wishlist-cart-error-message]');
      if (messageElement) messageElement.textContent = message;
      element.hidden = !message;
      if (message) scrollCartDrawerToError(element);
    });
  };

  const showCartDrawerError = (message) => {
    try {
      window.sessionStorage.setItem(CART_ERROR_KEY, message);
    } catch (error) {
      // A mensagem ainda será exibida no carrinho já renderizado.
    }
    document.querySelectorAll('[data-wishlist-cart-error]').forEach((element) => {
      const messageElement = element.querySelector('[data-wishlist-cart-error-message]');
      if (messageElement) messageElement.textContent = message;
      element.hidden = false;
      scrollCartDrawerToError(element);
    });
    window.clearTimeout(cartErrorTimer);
    cartErrorTimer = window.setTimeout(clearCartDrawerError, 8000);
  };

  const clearCartDrawerError = () => {
    window.clearTimeout(cartErrorTimer);
    try {
      window.sessionStorage.removeItem(CART_ERROR_KEY);
    } catch (error) {
      // Sem ação necessária.
    }
    document.querySelectorAll('[data-wishlist-cart-error]').forEach((element) => {
      const messageElement = element.querySelector('[data-wishlist-cart-error-message]');
      if (messageElement) messageElement.textContent = '';
      element.hidden = true;
    });
  };

  const toggle = (id) => {
    const productId = String(id);
    const items = read();
    const index = items.indexOf(productId);
    const added = index === -1;

    if (added) items.unshift(productId);
    else items.splice(index, 1);

    const saved = write(items);
    if (saved === false) {
      notify('Não foi possível salvar neste navegador.');
      return null;
    }

    updateInterface();
    document.dispatchEvent(new CustomEvent('wishlist:updated', { detail: { id: productId, added, items: saved } }));
    return added;
  };

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-wishlist-button]');
    if (!button) return;
    event.preventDefault();
    event.stopPropagation();
    const added = toggle(button.dataset.productId);
    if (added !== null) notify(added ? 'Produto salvo nos favoritos.' : 'Produto removido dos favoritos.');
  });

  class WishlistProducts extends HTMLElement {
    connectedCallback() {
      this.grid = this.querySelector('[data-wishlist-grid]');
      this.empty = this.querySelector('[data-wishlist-empty]');
      this.loading = this.querySelector('[data-wishlist-loading]');
      this.error = this.querySelector('[data-wishlist-error]');
      this.actions = this.querySelector('[data-wishlist-actions]');
      this.addSelectedButton = this.querySelector('[data-wishlist-add-selected]');
      this.cartStatus = this.querySelector('[data-wishlist-cart-status]');
      this.compare = this.querySelector('[data-wishlist-compare]');
      this.compareToggle = this.querySelector('[data-wishlist-compare-toggle]');
      this.compareButtonLabel = this.querySelector('[data-wishlist-compare-button-label]');
      this.compareIntro = this.querySelector('[data-wishlist-compare-intro]');
      this.compareHelp = this.querySelector('[data-wishlist-compare-help]');
      this.compareFinishWrapper = this.querySelector('[data-wishlist-compare-finish-wrapper]');
      this.compareStatus = this.querySelector('[data-wishlist-compare-status]');
      this.isComparing = false;
      this.handleUpdate = () => {
        this.setComparing(false);
        this.render();
      };
      this.handleSelectionChange = (event) => {
        if (this.cartStatus) this.cartStatus.textContent = '';
        if (event.target.matches('[data-wishlist-select]')) {
          event.target.closest('.wishlist-page__item-selector')?.classList.remove('has-cart-error');
          this.syncSelection();
        }
      };
      this.handleActionClick = (event) => {
        if (event.target.closest('[data-wishlist-compare-toggle]')) {
          event.preventDefault();
          this.setComparing(!this.isComparing);
          return;
        }

        if (event.target.closest('[data-wishlist-compare-finish]')) {
          event.preventDefault();
          this.setComparing(false);
          return;
        }

        if (this.isComparing && event.target.closest('[data-wishlist-item] a')) {
          event.preventDefault();
          event.stopPropagation();
          return;
        }

        if (event.target.closest('[data-wishlist-add-selected]')) this.addSelectedToCart();
      };
      this.handlePointerDown = (event) => this.onPointerDown(event);
      this.handlePointerMove = (event) => this.onPointerMove(event);
      this.handlePointerUp = (event) => this.onPointerUp(event);
      this.handleKeyDown = (event) => this.onCompareKeyDown(event);
      document.addEventListener('wishlist:updated', this.handleUpdate);
      this.addEventListener('change', this.handleSelectionChange);
      this.addEventListener('click', this.handleActionClick);
      this.addEventListener('pointerdown', this.handlePointerDown);
      this.addEventListener('keydown', this.handleKeyDown);
      document.addEventListener('pointermove', this.handlePointerMove, { passive: false });
      document.addEventListener('pointerup', this.handlePointerUp);
      document.addEventListener('pointercancel', this.handlePointerUp);
      this.render();
    }

    disconnectedCallback() {
      document.removeEventListener('wishlist:updated', this.handleUpdate);
      this.removeEventListener('change', this.handleSelectionChange);
      this.removeEventListener('click', this.handleActionClick);
      this.removeEventListener('pointerdown', this.handlePointerDown);
      this.removeEventListener('keydown', this.handleKeyDown);
      document.removeEventListener('pointermove', this.handlePointerMove);
      document.removeEventListener('pointerup', this.handlePointerUp);
      document.removeEventListener('pointercancel', this.handlePointerUp);
      this.finishDrag(false);
      if (this.controller) this.controller.abort();
    }

    setState(state) {
      this.loading.hidden = state !== 'loading';
      this.empty.hidden = state !== 'empty';
      this.error.hidden = state !== 'error';
      this.grid.hidden = state !== 'ready';
      if (this.actions) this.actions.hidden = state !== 'ready';
      if (this.compare) {
        const hasEnoughItems = this.grid.querySelectorAll('[data-wishlist-item]').length > 1;
        this.compare.hidden = state !== 'ready' || !hasEnoughItems;
      }
      if (state !== 'ready' && this.isComparing) this.setComparing(false);
    }

    getGridItems() {
      return [...this.grid.querySelectorAll(':scope > [data-wishlist-item]')];
    }

    getItemProductId(item) {
      return item?.querySelector('[data-wishlist-button]')?.dataset.productId || '';
    }

    getItemProductTitle(item) {
      return item?.querySelector('[data-wishlist-button]')?.dataset.productTitle || 'Produto';
    }

    announceCompare(message) {
      if (!this.compareStatus) return;
      this.compareStatus.textContent = '';
      window.requestAnimationFrame(() => {
        this.compareStatus.textContent = message;
      });
    }

    setComparing(active) {
      const next = Boolean(active && this.getGridItems().length > 1);
      const changed = next !== this.isComparing;
      if (!next) this.finishDrag(false);
      this.isComparing = next;
      this.classList.toggle('is-comparing', next);
      this.grid.classList.toggle('is-comparing', next);
      this.compare?.classList.toggle('is-active', next);

      if (this.compareToggle) {
        this.compareToggle.setAttribute('aria-pressed', String(next));
        const label = next
          ? this.compareToggle.dataset.labelActive
          : this.compareToggle.dataset.labelDefault;
        if (this.compareButtonLabel) this.compareButtonLabel.textContent = label;
      }
      if (this.compareIntro) this.compareIntro.hidden = next;
      if (this.compareHelp) this.compareHelp.hidden = !next;
      if (this.compareFinishWrapper) this.compareFinishWrapper.hidden = !next;

      this.getGridItems().forEach((item) => {
        const image = item.querySelector('.product-card__image-wrapper');
        if (!image) return;
        if (next) {
          const title = this.getItemProductTitle(item);
          image.setAttribute('tabindex', '0');
          image.setAttribute('role', 'button');
          image.setAttribute('aria-label', `Mover ${title}. Use as setas do teclado para alterar a posição.`);
        } else {
          image.removeAttribute('tabindex');
          image.removeAttribute('role');
          image.removeAttribute('aria-label');
        }
      });

      if (changed) {
        this.announceCompare(next
          ? 'Modo de organização ativado. Arraste as peças para reorganizá-las.'
          : 'Modo de organização encerrado.');
      }
    }

    applySavedOrder(ids) {
      const items = this.getGridItems();
      const byId = new Map(items.map((item) => [this.getItemProductId(item), item]));
      const orderedIds = new Set(ids.map(String));
      ids.forEach((id) => {
        const item = byId.get(String(id));
        if (item) this.grid.appendChild(item);
      });
      items.forEach((item) => {
        if (!orderedIds.has(this.getItemProductId(item))) this.grid.appendChild(item);
      });
    }

    saveGridOrder() {
      const visibleOrder = this.getGridItems().map((item) => this.getItemProductId(item)).filter(Boolean);
      const visibleIds = new Set(visibleOrder);
      const remaining = read().filter((id) => !visibleIds.has(id));
      const saved = write([...visibleOrder, ...remaining]);
      if (saved === false) notify('Não foi possível salvar a nova ordem neste navegador.');
      return saved;
    }

    onPointerDown(event) {
      if (!this.isComparing || event.button > 0) return;
      const image = event.target.closest('.product-card__image-wrapper');
      const item = image?.closest('[data-wishlist-item]');
      if (!image || !item || item.parentElement !== this.grid) return;
      if (event.target.closest('button, input, label')) return;

      event.preventDefault();
      this.finishDrag(false);
      this.dragState = {
        pointerId: event.pointerId,
        item,
        image,
        startX: event.clientX,
        startY: event.clientY,
        clientX: event.clientX,
        clientY: event.clientY,
        dragging: false,
        moved: false,
      };
    }

    startDrag() {
      const state = this.dragState;
      if (!state || state.dragging) return;
      const rect = state.item.getBoundingClientRect();
      const ghost = state.item.cloneNode(true);
      ghost.classList.add('wishlist-page__drag-ghost');
      ghost.removeAttribute('data-wishlist-item');
      ghost.setAttribute('aria-hidden', 'true');
      ghost.style.left = `${rect.left}px`;
      ghost.style.top = `${rect.top}px`;
      ghost.style.width = `${rect.width}px`;
      ghost.style.height = `${rect.height}px`;

      state.rect = rect;
      state.ghost = ghost;
      state.dragging = true;
      state.item.classList.add('is-dragging-origin');
      document.body.classList.add('wishlist-is-dragging');
      document.body.appendChild(ghost);
    }

    onPointerMove(event) {
      const state = this.dragState;
      if (!state || event.pointerId !== state.pointerId) return;

      state.clientX = event.clientX;
      state.clientY = event.clientY;
      const distance = Math.hypot(event.clientX - state.startX, event.clientY - state.startY);
      if (!state.dragging && distance < 6) return;

      event.preventDefault();
      if (!state.dragging) this.startDrag();
      if (!state.ghost) return;

      const offsetX = event.clientX - state.startX;
      const offsetY = event.clientY - state.startY;
      state.ghost.style.transform = `translate3d(${offsetX}px, ${offsetY}px, 0) rotate(0.5deg)`;

      this.reorderDraggedItem(event.clientX, event.clientY);

      const headerHeight = parseFloat(
        window.getComputedStyle(document.documentElement).getPropertyValue('--header-height')
      ) || 0;
      const topEdge = Math.min(window.innerHeight * 0.4, headerHeight + 96);
      const bottomEdge = 72;
      const speed = 14;
      if (event.clientY < topEdge) window.scrollBy(0, -speed);
      else if (event.clientY > window.innerHeight - bottomEdge) window.scrollBy(0, speed);
    }

    reorderDraggedItem(clientX, clientY) {
      const state = this.dragState;
      if (!state?.dragging) return;
      const candidates = this.getGridItems().filter((item) => item !== state.item);
      if (!candidates.length) return;

      const target = candidates.reduce((closest, item) => {
        const rect = item.getBoundingClientRect();
        const distance = Math.hypot(clientX - (rect.left + rect.width / 2), clientY - (rect.top + rect.height / 2));
        return !closest || distance < closest.distance ? { item, rect, distance } : closest;
      }, null);
      if (!target) return;

      const centerX = target.rect.left + target.rect.width / 2;
      const centerY = target.rect.top + target.rect.height / 2;
      const sameRow = Math.abs(clientY - centerY) < target.rect.height * 0.3;
      const insertBefore = sameRow ? clientX < centerX : clientY < centerY;
      const currentIndex = this.getGridItems().indexOf(state.item);
      const reference = insertBefore ? target.item : target.item.nextElementSibling;

      if (reference !== state.item) this.grid.insertBefore(state.item, reference);
      const nextIndex = this.getGridItems().indexOf(state.item);
      if (nextIndex !== currentIndex) state.moved = true;
    }

    onPointerUp(event) {
      const state = this.dragState;
      if (!state || event.pointerId !== state.pointerId) return;
      if (state.dragging) event.preventDefault();
      this.finishDrag(true);
    }

    finishDrag(saveOrder = true) {
      const state = this.dragState;
      if (!state) return;

      state.item?.classList.remove('is-dragging-origin');
      state.ghost?.remove();
      document.body.classList.remove('wishlist-is-dragging');
      this.dragState = null;

      if (saveOrder && state.dragging && state.moved) {
        const saved = this.saveGridOrder();
        const position = this.getGridItems().indexOf(state.item) + 1;
        if (saved !== false) {
          this.announceCompare(`${this.getItemProductTitle(state.item)} movido para a posição ${position}.`);
        }
      }
    }

    onCompareKeyDown(event) {
      if (!this.isComparing || !['ArrowLeft', 'ArrowUp', 'ArrowRight', 'ArrowDown'].includes(event.key)) return;
      const image = event.target.closest('.product-card__image-wrapper');
      const item = image?.closest('[data-wishlist-item]');
      if (!image || !item || item.parentElement !== this.grid) return;

      event.preventDefault();
      const items = this.getGridItems();
      const currentIndex = items.indexOf(item);
      const direction = ['ArrowLeft', 'ArrowUp'].includes(event.key) ? -1 : 1;
      const nextIndex = Math.max(0, Math.min(items.length - 1, currentIndex + direction));
      if (nextIndex === currentIndex) return;

      const target = items[nextIndex];
      const reference = direction < 0 ? target : target.nextElementSibling;
      this.grid.insertBefore(item, reference);
      const saved = this.saveGridOrder();
      image.focus();
      if (saved !== false) {
        this.announceCompare(`${this.getItemProductTitle(item)} movido para a posição ${nextIndex + 1}.`);
      }
    }

    syncSelection() {
      this.grid.querySelectorAll('[data-wishlist-select]').forEach((checkbox) => {
        const selector = checkbox.closest('.wishlist-page__item-selector');
        if (selector) selector.classList.toggle('is-selected', checkbox.checked);
      });
      const available = [...this.grid.querySelectorAll('[data-wishlist-select]:not(:disabled)')];
      const selected = available.filter((checkbox) => checkbox.checked);
      if (this.addSelectedButton) this.addSelectedButton.disabled = selected.length === 0;
    }

    renderCartResult(addedCount, failures) {
      if (!this.cartStatus) return;
      this.cartStatus.textContent = '';

      if (addedCount > 0) {
        const success = document.createElement('p');
        success.className = 'wishlist-page__cart-success';
        success.textContent = addedCount === 1
          ? '1 produto adicionado ao carrinho.'
          : `${addedCount} produtos adicionados ao carrinho.`;
        this.cartStatus.appendChild(success);
      }

    }

    markFailedItems(failures) {
      this.grid.querySelectorAll('.wishlist-page__item-selector.has-cart-error').forEach((selector) => {
        selector.classList.remove('has-cart-error');
      });

      failures.forEach((failure) => {
        const checkbox = [...this.grid.querySelectorAll('[data-wishlist-select]')]
          .find((item) => String(item.value) === String(failure.id));
        checkbox?.closest('.wishlist-page__item-selector')?.classList.add('has-cart-error');
      });
    }

    async addSelectedToCart() {
      const selected = [...this.grid.querySelectorAll('[data-wishlist-select]:checked:not(:disabled)')];
      if (!selected.length || !this.addSelectedButton) return;

      const items = selected.map((checkbox) => ({
        id: Number(checkbox.value),
        quantity: 1,
        title: checkbox.dataset.productTitle || 'Produto',
      }));
      const originalLabel = this.addSelectedButton.textContent;
      this.addSelectedButton.disabled = true;
      this.addSelectedButton.textContent = 'Adicionando…';
      if (this.cartStatus) this.cartStatus.textContent = '';
      this.markFailedItems([]);

      try {
        let addedCount = 0;
        const failures = [];

        for (const item of items) {
          try {
            const response = await fetch(this.dataset.cartAddUrl, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ items: [{ id: item.id, quantity: item.quantity }] }),
              credentials: 'same-origin',
            });
            const result = await response.json();
            if (!response.ok) {
              throw new Error(result.description || result.message || 'Não foi possível adicionar este produto.');
            }
            addedCount += 1;
          } catch (error) {
            failures.push({
              id: item.id,
              title: item.title,
              message: normalizeCartError(error.message) || 'Não foi possível adicionar este produto.',
            });
          }
        }

        this.markFailedItems(failures);
        this.renderCartResult(addedCount, failures);
        if (failures.length > 0) {
          const errorMessage = 'Os itens marcados com ✕ não foram adicionados. A última unidade já está no carrinho.';
          showCartDrawerError(errorMessage);
        }
        if (addedCount > 0 || failures.length > 0) {
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { open: true } }));
        }
      } catch (error) {
        const message = normalizeCartError(error.message) || 'Não foi possível adicionar os produtos ao carrinho.';
        this.renderCartResult(0, [{ title: 'Produtos selecionados', message }]);
        notify(message);
      } finally {
        this.addSelectedButton.textContent = originalLabel;
        this.syncSelection();
      }
    }

    async render() {
      const ids = read();
      if (!ids.length) {
        this.grid.innerHTML = '';
        this.setState('empty');
        return;
      }

      this.setState('loading');
      if (this.controller) this.controller.abort();
      this.controller = new AbortController();

      const url = new URL(this.dataset.searchUrl, window.location.origin);
      url.searchParams.set('section_id', this.dataset.sectionId);
      url.searchParams.set('type', 'product');
      url.searchParams.set('q', ids.map((id) => `id:${id}`).join(' OR '));

      try {
        const response = await fetch(url, { signal: this.controller.signal, credentials: 'same-origin' });
        if (!response.ok) throw new Error(`HTTP ${response.status}`);
        const html = await response.text();
        const parsed = new DOMParser().parseFromString(html, 'text/html');
        const source = parsed.querySelector('wishlist-products [data-wishlist-grid]');
        if (!source) throw new Error('Wishlist section not found');

        this.grid.innerHTML = source.innerHTML;
        this.applySavedOrder(ids);
        const renderedIds = [...new Set(this.getGridItems().map((item) => this.getItemProductId(item)).filter(Boolean))];

        if (!renderedIds.length) {
          write([]);
          updateInterface();
          this.setState('empty');
          return;
        }

        if (renderedIds.length < ids.length) write(ids.filter((id) => renderedIds.includes(id)));

        updateInterface();
        this.setState('ready');
        this.syncSelection();
      } catch (error) {
        if (error.name !== 'AbortError') this.setState('error');
      }
    }
  }

  if (!customElements.get('wishlist-products')) customElements.define('wishlist-products', WishlistProducts);

  document.addEventListener('cart:updated', renderCartDrawerError);
  document.addEventListener('drawer:handleAfterShow', (event) => {
    if (event.target.matches('cart-drawer')) renderCartDrawerError();
  });
  document.addEventListener('drawer:handleAfterHide', (event) => {
    if (event.target.matches('cart-drawer')) clearCartDrawerError();
  });

  window.DaljiWishlist = {
    read,
    contains,
    toggle,
    updateInterface,
    showCartDrawerError,
    clearCartDrawerError,
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', updateInterface, { once: true });
  } else {
    updateInterface();
  }

  new MutationObserver((mutations) => {
    const items = read();
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType !== Node.ELEMENT_NODE) return;
        if (node.matches('[data-wishlist-button]')) updateButton(node, items);
        node.querySelectorAll('[data-wishlist-button]').forEach((button) => updateButton(button, items));
      });
    });
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
